export const noChoice = [7];
